function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { createElement, useEffect, useState } from 'react';
import { Avatar, Comment, Tooltip, Typography } from 'antd';
import { DislikeOutlined, LikeOutlined, DislikeFilled, LikeFilled } from '@ant-design/icons';
import moment from 'moment';
import client from '../feathers';
var {
  Link,
  Text
} = Typography;

function Scenario(_ref) {
  var {
    scenarioId,
    endpoint: {
      provider: {
        image,
        name: providerName
      }
    },
    name,
    description,
    category,
    keywords,
    likes: defaultLikes,
    dislikes: defaultDislikes
  } = _ref;
  var [likes, setLikes] = useState(defaultLikes);
  var [dislikes, setDislikes] = useState(defaultDislikes);
  var [action, setAction] = useState(null);
  var [updated, setUpdated] = useState(false);

  var like = () => {
    setLikes(defaultLikes + 1);
    setDislikes(defaultDislikes);
    setAction('liked');
  };

  var dislike = () => {
    setLikes(defaultLikes);
    setDislikes(defaultDislikes + 1);
    setAction('disliked');
  };

  useEffect(() => {
    function increment(_x) {
      return _increment.apply(this, arguments);
    }

    function _increment() {
      _increment = _asyncToGenerator(function* (_ref2) {
        var {
          scenarioId,
          likes,
          dislikes
        } = _ref2;

        try {
          var service = client.service('scenarios');
          var updateData = {
            likes,
            dislikes
          };
          yield service.patch(scenarioId, updateData);
          return setUpdated(true);
        } catch (e) {
          // Do nothing
          return setUpdated(false);
        }
      });
      return _increment.apply(this, arguments);
    }

    increment({
      scenarioId,
      likes,
      dislikes
    });
  }, [scenarioId, likes, dislikes]);
  var actions = [/*#__PURE__*/React.createElement(Tooltip, {
    key: "comment-basic-like",
    title: "Like"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: like
  }, /*#__PURE__*/createElement(action === 'liked' ? LikeFilled : LikeOutlined), /*#__PURE__*/React.createElement("span", {
    className: "comment-action"
  }, likes))), /*#__PURE__*/React.createElement(Tooltip, {
    key: "comment-basic-dislike",
    title: "Dislike"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: dislike
  }, /*#__PURE__*/React.createElement(action === 'disliked' ? DislikeFilled : DislikeOutlined), /*#__PURE__*/React.createElement("span", {
    className: "comment-action"
  }, dislikes)))];
  return /*#__PURE__*/React.createElement("div", {
    className: "scenario"
  }, /*#__PURE__*/React.createElement(Comment, {
    avatar: /*#__PURE__*/React.createElement(Tooltip, {
      title: "Source: ".concat(providerName)
    }, /*#__PURE__*/React.createElement(Avatar, {
      src: image,
      alt: "Han Solo"
    })),
    actions: actions,
    author: /*#__PURE__*/React.createElement(Link, null, name),
    content: description,
    datetime: /*#__PURE__*/React.createElement(Tooltip, {
      title: moment().format('YYYY-MM-DD HH:mm:ss')
    }, /*#__PURE__*/React.createElement("span", null, moment().fromNow()))
  }));
}

Scenario.defaultProps = {
  name: 'Top Totalvolfull, PRICE > OPEN',
  description: 'Comparing RAW.USD.PRICE greater than RAW.USD.OPENDAY',
  category: 'historical',
  keywords: 'scenarios',
  endpoint: {
    provider: {
      image: '',
      name: 'Cryptosheets'
    }
  },
  likes: 0,
  dislikes: 0
};
export default Scenario;